// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Gallery_modalOverlay__V4IDJ","modalContent":"Gallery_modalContent__eh6ma","modalImage":"Gallery_modalImage__ZaAMU"};